export default {
    routes: {
        home: '首页',
        monitor: '监测',
        application: '应用',
        business: '业务',
        device: '探测设备',
        exception: '异常',
        account: '账号',
        log: '日志',
        sys: '系统',
        instance: '设备数据',
        map: '地图数据',
        grid: '列表数据',
        scene: '组织架构',
        organizationStructure: '组织架构',
        history: '历史数据',
        monitorTask: '检测任务',
        proberange: '监测区间',
        collectRecord: '采集数据',
        contact: '联系人',
        alarmTrigger: '报警触发',
        incubator: '保温箱',
        fridge: '冰箱',
        car: '车辆',
        refrigeratory: '冷库',
        sensor: '传感器',
        gateway: '网关',
        display: '显示屏',
        relay: '中继',
        ex: '异常记录',
        exReason: '异常原因',
        user: '用户',
        role: '角色',
        noticelog: '通知日志',
        sysLog: '系统日志',
        param: '参数',
        forwarding: '转发设置',
        resource: '访问资源',
        probeunit: '计量单位',
        customer: '客户',
        count: '报表统计',
        // 前端添加
        personalinfo: '个人档案',
        historyData: '历史记录',
        realtime: '实时数据',
        operateRecord: '操作记录'
    }
};
